export var Bucket;
(function (Bucket) {
    Bucket[Bucket["ONE"] = 0] = "ONE";
    Bucket[Bucket["THREE"] = 1] = "THREE";
    Bucket[Bucket["FIVE"] = 2] = "FIVE";
})(Bucket || (Bucket = {}));
